import React, {forwardRef} from 'react';
import {type Components} from 'react-virtuoso';

import {
  EmptyPanelBankMessage,
  EmptyPanelSearchMessage,
} from '../emptyState/EmptyMessages';
import {type SectionWithRef} from '../types';
import {AddSectionButton} from './AddSectionButton';

export type VirtuosoContext = {
  isProjectReadOnly: boolean;
  isSearching: boolean;
  numVisibleSections: number;
  shouldDisplaySectionContent: boolean;
};

export const virtuosoComponents: Components<SectionWithRef, VirtuosoContext> = {
  Footer: forwardRef<HTMLDivElement, {context: VirtuosoContext}>(
    ({context}, ref) => {
      if (!context?.numVisibleSections) {
        return null;
      }

      return (
        <div
          ref={ref}
          style={{
            padding: '1rem 2rem',
            display: 'flex',
            justifyContent: 'flex-end',
          }}>
          <AddSectionButton />
        </div>
      );
    }
  ),
  EmptyPlaceholder: forwardRef<HTMLDivElement, {context: VirtuosoContext}>(
    ({context}, ref) => {
      const {isSearching} = context!;

      return (
        <div ref={ref} style={{height: '100%'}}>
          {isSearching ? (
            <EmptyPanelSearchMessage />
          ) : (
            <EmptyPanelBankMessage />
          )}
        </div>
      );
    }
  ),
};
